import { signInWithGoogle, logoutUser } from '../services/firebase.js';

export function renderAuthModal(container, { isOpen, user, onClose, onLoginSuccess }) {
  if (!isOpen && user) {
    container.innerHTML = '';
    return;
  }

  container.innerHTML = `
    <div class="sheet-backdrop ${!user ? 'open' : (isOpen ? 'open' : '')}" id="auth-backdrop"></div>
    <div class="sheet-modal ${!user ? 'open' : (isOpen ? 'open' : '')}" style="top: 18%; padding: 28px; text-align: center;">
      <div class="sheet-handle-bar"></div>
      
      <div style="margin: 16px 0 20px 0;">
        <div style="width: 64px; height: 64px; border-radius: 50%; background: var(--signal-blue-bg); display: flex; align-items: center; justify-content: center; margin: 0 auto 16px auto;">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--signal-blue)" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
        </div>
        <h2 style="font-family: var(--font-display); font-size: 24px; font-weight: 700; color: var(--ink-primary); margin-bottom: 8px;">
          ${user ? 'Account Management' : 'Protected Notes'}
        </h2>
        <p style="font-size: 14px; color: var(--ink-secondary); line-height: 1.5; max-width: 290px; margin: 0 auto;">
          ${user 
            ? `Signed in as <strong style="color: var(--ink-primary);">${escapeHtml(user.email || user.displayName || 'User')}</strong>` 
            : 'Sign in with your Google account to secure your notes and sync across Mac Desktop and Mobile in real-time.'}
        </p>
      </div>

      <div id="auth-error-banner" style="display: none; background: #FEF2F2; border: 1px solid #FCA5A5; color: #991B1B; padding: 12px; border-radius: 12px; font-size: 13px; text-align: left; margin-bottom: 16px; line-height: 1.4;">
      </div>

      ${!user ? `
        <button class="chip-btn" id="btn-google-login" style="background: #4285F4; color: white; width: 100%; height: 50px; font-size: 16px; font-weight: 700; display: flex; align-items: center; justify-content: center; gap: 10px; border-radius: 14px; box-shadow: 0 4px 14px rgba(66, 133, 244, 0.3);">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="white"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22.81-.63z"/><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z"/></svg>
          Sign in with Google
        </button>
      ` : `
        <button class="chip-btn" id="btn-google-logout" style="background: rgba(220,38,38,0.1); color: #DC2626; width: 100%; height: 46px; font-size: 15px; font-weight: 700; border-radius: 12px;">
          Sign Out
        </button>
      `}
    </div>
  `;

  const backdrop = container.querySelector('#auth-backdrop');
  if (backdrop && user) backdrop.onclick = onClose;

  const loginBtn = container.querySelector('#btn-google-login');
  const errorBanner = container.querySelector('#auth-error-banner');

  if (loginBtn) {
    loginBtn.onclick = async () => {
      if (errorBanner) errorBanner.style.display = 'none';
      try {
        const u = await signInWithGoogle();
        if (onLoginSuccess && u) onLoginSuccess(u);
      } catch (err) {
        console.error("Login error:", err);
        if (errorBanner) {
          errorBanner.style.display = 'block';
          if (err.code === 'auth/unauthorized-domain' || err.message?.includes('unauthorized-domain')) {
            const currentDomain = window.location.hostname;
            errorBanner.innerHTML = `
              <strong>Domain Not Authorized in Firebase</strong><br>
              The domain <code>${currentDomain}</code> is not in Firebase Auth's Authorized Domains.<br><br>
              <strong>Fix options:</strong><br>
              1. Open the app via <code>http://localhost:3000</code><br>
              2. Or add <code>${currentDomain}</code> in <em>Firebase Console ➔ Authentication ➔ Settings ➔ Authorized Domains</em>.
            `;
          } else {
            errorBanner.textContent = `Sign-in error: ${err.message || err.code || err}`;
          }
        }
      }
    };
  }

  const logoutBtn = container.querySelector('#btn-google-logout');
  if (logoutBtn) {
    logoutBtn.onclick = async () => {
      await logoutUser();
      if (onClose) onClose();
    };
  }
}

function escapeHtml(str) {
  return str.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
